<template>
    <div class="items-center justify-between block rounded-b-xl sm:flex md:flex">

        <div class=" hidden lg:flex gap-2 items-center">
            <change-page @pageChange="pageChange"></change-page>
            <span class="text-sm text-gray-700 dark:text-gray-400 font-normal">{{ trans("lang.hrm.showing") }}
                <span class="font-bold">{{ pageData?.from }}</span>
                {{ trans("lang.hrm.to") }}
                <span class="font-bold"> {{ pageData?.to }} </span>
                {{ trans("lang.hrm.of") }}
                <span class="font-bold"> {{ pageData?.total }} </span>
                {{ trans("lang.labels.page_entries") }}</span>

        </div>

        <div>
            <Pagination v-if="pagination.lastPage != 1" @refreshTable="refreshTable"
                :currentPage="pagination.currentPage" :lastPage="pagination.lastPage" :total="pagination.total" />
        </div>

    </div>
</template>
<script>
import Pagination from '../Pagination.vue';
export default {
    components: {
        Pagination
    },
    props: {
        pageData: {
            type: Object,
        },
        pagination: {
            type: Object,
        },
    },
    methods: {
        refreshTable(page) {
            this.$emit('refreshTable', page)
        },
        pageChange(page) {
            this.$emit('pageChange', page)
        }
    }
}
</script>